/*
Title: Button

Description:
This component renders a customizable button. It supports various attributes via the `props` parameter and can be used to create primary or secondary buttons based on the styles provided in the associated SCSS file.

Props:
- children: (node) Required. The content to be displayed inside the button.
- ...props: Additional button attributes (e.g., onClick, type) that can be passed to the button element.

Usage:
1. Import the Button component into your React application.
2. Use the component and pass any necessary props or children.

Example:
<Button onClick={() => alert('Button clicked!')}>Click Me</Button>

Author: thesyscoder
*/

import React from "react";
import "./Button.style.scss";

/**
 * Button component for rendering a customizable button.
 *
 * @param {object} props - The properties passed to the button element.
 * @param {node} props.children - The content to be displayed inside the button.
 * @returns {JSX.Element} The rendered button element.
 */
const Button = ({ children, ...props }) => {
  return <button {...props}>{children}</button>;
};

export default React.memo(Button);
